import { IApplicationContext } from 'shared/map-search/types/applicationContext';
import { IApplicationState } from 'shared/map-search/types/redux';
import { createReduxStore } from 'shared/map-search/utils/redux';

export function createApplicationState(context: IApplicationContext) {
  const initialState = context.config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, context);
}
